<div class="basic-container">
  <mat-spinner
    [diameter]="diameter"
    frodoCustomSpinner
    [strokeWidth]="strokeWidth"
    [color]="colorSpinner"
  ></mat-spinner>
  <img alt="" [src]="src" [ngClass]="{ big: isBigClass, small: !isBigClass }" />
</div>
